
import axios from 'axios';
import config from '../../config';
import { getAxiosConfigUserToken } from '../../util/utilFunction';

export const getItemReviewAllApi = async()=>{
    const url = `${config.apiUrl}/v1/itemReview/`;
    return await axios.get(url,getAxiosConfigUserToken())
    .then(response => response.data)
 }
 export const getItemReviewByItemIdApi = async(itemId)=>{
   const url = `${config.apiUrl}/v1/itemReview/byItemId/${itemId}`;
   return await axios.get(url,getAxiosConfigUserToken())
   .then(response => response.data)
}
export const getItemReviewByIdApi = async(id)=>{
   const url = `${config.apiUrl}/v1/itemReview/${id}`;
   return await axios.get(url,getAxiosConfigUserToken())
   .then(response => response.data)
}
export const getItemReviewFullByItemIdApi = async(itemId)=>{
   //buradaki fark hakem isimleride var.
   const url = `${config.apiUrl}/v1/itemReview/full/byItemId/${itemId}`;
   return await axios.get(url,getAxiosConfigUserToken())
   .then(response => response.data)
}

export const getItemReviewByUserIdApi = async(userId)=>{
    const url = `${config.apiUrl}/v1/itemReview/byUserId/${userId}`;
    return await axios.get(url,getAxiosConfigUserToken())
    .then(response => response.data)
 }
 export const getItemReviewByRefereeIdApi = async(refereeId)=>{
    const url = `${config.apiUrl}/v1/itemReview/byRefereeId/${refereeId}`;
    return await axios.get(url,getAxiosConfigUserToken())
    .then(response => response.data)
 }
export const deleteItemReviewByItemIdApi = async(itemId)=>{
    const url = `${config.apiUrl}/v1/itemReview/byItemId/${itemId}`;
    return await axios.delete(url,getAxiosConfigUserToken())
    .then(response => response.data)
 }
 export const deleteItemReviewByIdApi = async(id)=>{
    const url = `${config.apiUrl}/v1/itemReview/${id}`;
    return await axios.delete(url,getAxiosConfigUserToken())
    .then(response => response.data)
 }
 export const postSaveItemReviewApi = (ItemReview)=>{
    const url = `${config.apiUrl}/v1/itemReview/`;
    return axios.post(url,ItemReview,getAxiosConfigUserToken())
    .then(response => response.data);
 }
 export const putUpdateItemReviewApi = (ItemReview)=>{
    const url = `${config.apiUrl}/v1/itemReview/`;
    return axios.put(url,ItemReview,getAxiosConfigUserToken())
    .then(response => response.data);
 }
 export const putUpdateItemReviewByItemIdApi = (ItemReview)=>{
   const url = `${config.apiUrl}/v1/itemReview/byItemId/`;
   return axios.put(url,ItemReview,getAxiosConfigUserToken())
   .then(response => response.data);
}
export const putUpdateItemReviewByItemIdAndDecisionApi = (ItemReview,decision)=>{
   const url = `${config.apiUrl}/v1/itemReview/byItemIdAndDecision/${decision}`;
   return axios.put(url,ItemReview,getAxiosConfigUserToken())
   .then(response => response.data);
}
 export const postSaveItemReviewListApi = (itemReviewList)=>{
    const url = `${config.apiUrl}/v1/itemReview/list/`;
    return axios.post(url,itemReviewList,getAxiosConfigUserToken())
    .then(response => response.data);
 }
 


 export const getItemReviewReportPDFByIdApi = (id,lang,visibility)=>{
   const url = `${config.apiUrl}/v1/pdf/itemReview/${id}/?lang=${lang}&visibility=${visibility}`;
   return axios.get(url,{
      method: 'GET',
      responseType: 'blob',
      ...getAxiosConfigUserToken()
   })
   .then(response => {
      const file = new Blob(
         [response.data], 
         {type: 'application/pdf'});
         return file;
   });
}


export const postItemReviewByRefereeIdAndDecisionListApi = (refereeIdAndDecisionList)=>{
    const url = `${config.apiUrl}/v1/itemReview/byRefereeIdAndDecisionList/`;
    return axios.post(url,refereeIdAndDecisionList,getAxiosConfigUserToken())
    .then(response => response.data);
 }
 export const postItemReviewAndItemInfoByRefereeIdAndDecisionListApi = (refereeIdAndDecisionList)=>{
   const url = `${config.apiUrl}/v1/itemReview/itemInfo/byRefereeIdAndDecisionList/`;
   return axios.post(url,refereeIdAndDecisionList,getAxiosConfigUserToken())
   .then(response => response.data);
}

export const getItemReviewByCorrectionCodeApi = async(CorrectionCode)=>{
   const url = `${config.apiUrl}/v1/itemReview/byCorrectionCode/${CorrectionCode}`;
   return await axios.get(url,getAxiosConfigUserToken())
   .then(response => response.data)
}

export const getItemReviewRefereeDocumentPDFByIdApi = (id,lang)=>{
   const url = `${config.apiUrl}/v1/pdf/itemReviewRefereeDocument/${id}/?lang=${lang}`;
   return axios.get(url,{
      method: 'GET',
      responseType: 'blob',
      ...getAxiosConfigUserToken()
   })
   .then(response => {
      const file = new Blob(
         [response.data], 
         {type: 'application/pdf'});
         return file;
   });
}

export const postItemReviewStatisticsRefereeByRefereeIdApi = async(refereeIdList)=>{
   const url = `${config.apiUrl}/v1/itemReview/statisticsReferee/byRefereeIdList/`;
   return await axios.post(url,{refereeIdList},getAxiosConfigUserToken())
   .then(response => response.data)
}